module.exports = __webpack_public_path__ + "login/img/logo4login.e2d3fac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo4login.png
// module id = qrmP
// module chunks = 2